import { useQuery } from '@apollo/client'
import React, { use, useContext, useEffect, useState } from 'react'
import {
  DELETE_TRUCK,
  GET_ALL_TRUCKS,
  GET_CAPACITY_TRUCKS,
  GET_STATUS_TRUCKS,
} from '../../../../graphql/Catalog/Trucks/trucks'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import TrucksNew from './TrucksNew'
import { AuthContext } from '../../../../Auth/AuthContext'
import { GET_ALL_PROVIDERS } from '../../../../graphql/Catalog/Providers/providers'

const Trucks = () => {
  const { user } = useContext(AuthContext)
  const [dataTable, setDataTable] = useState([])
  const [formModal, setFormModal] = useState(false)
  const [truckId, setTruckId] = useState(null)
  const [count, setCount] = useState(0)
  const [userProvider, setUserProvider] = useState(!!user.provider_id)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      status: null,
      provider_id: null,
      capacity: null,
    },
  })
  const [options, setOptions] = useState({
    status: [],
    provider_id: [],
    capacity: [],
  })

  const { loading, data, error, refetch } = useQuery(GET_ALL_TRUCKS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
      filters: pagePagination.filters,
    },
    fetchPolicy: 'no-cache',
  })

  const {
    loading: loadingCapacity,
    error: errorCapacity,
    data: dataCapacity,
  } = useQuery(GET_CAPACITY_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingStatus,
    error: errorStatus,
    data: dataStatus,
  } = useQuery(GET_STATUS_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingProviders,
    error: errorProviders,
    data: dataProviders,
  } = useQuery(GET_ALL_PROVIDERS, {
    variables: {},
    skip: userProvider,
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error
      if (!data) return

      const { getAllTrucks } = data

      const infoTrucks = getAllTrucks.rows.map((truck) => {
        return {
          id: truck.id,
          ...(!userProvider && {
            proveedor: truck.TrucksToProviders?.card_name,
          }),
          ...(truck.TrucksToUsersDrivers && {
            conductor: `${truck.TrucksToUsersDrivers.name} ${truck.TrucksToUsersDrivers.first_name}`,
          }),
          placa: truck.plate_number,
          tipo: truck.type,
          estado: truck.status,
          capacidad: truck.capacity + 'm³',
        }
      })

      setDataTable(infoTrucks)
      setCount(getAllTrucks.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  useEffect(() => {
    try {
      if (loadingCapacity) return
      if (errorCapacity) throw errorCapacity.message
      if (!dataCapacity)
        throw new Error('No se encontraron datos de las capacidades')

      const { getCapacityForTruck } = dataCapacity

      setOptions((prev) => ({
        ...prev,
        capacity: getCapacityForTruck,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingCapacity, errorCapacity, dataCapacity])

  useEffect(() => {
    try {
      if (loadingStatus) return
      if (errorStatus) throw errorStatus.message
      if (!dataStatus) throw new Error('No se encontraron datos de los estados')

      const { getStatusForTruck } = dataStatus

      setOptions((prev) => ({
        ...prev,
        status: getStatusForTruck,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: `${error.message}`,
      })
    }
  }, [loadingStatus, errorStatus, dataStatus])

  useEffect(() => {
    if (userProvider) return
    try {
      if (loadingProviders) return
      if (errorProviders) throw errorProviders
      let list = []
      dataProviders.getAllProviders.rows.map((provider) => {
        return list.push({
          value: provider.id,
          label: `${provider.card_name} - ${provider.rfc}`,
        })
      })

      setOptions((prev) => ({
        ...prev,
        provider_id: list,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataProviders, errorProviders, loadingProviders])

  const handleEdit = (id) => {
    setTruckId(id)
    setFormModal(true)
  }

  const handleFilterChange = (e, key) => {
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [key]: e ? e.value : null,
      },
    }))
  }

  return (
    <>
      <ContentHeader title="Camiones" windowTitle="Camiones" breadcrumb="" />
      <LayoutTable
        hideAddNew
        hideId
        data={dataTable}
        totalCount={count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        title="Lista de Camiones"
        gql={DELETE_TRUCK}
        refetchFunctionQueries={refetch}
        showAddNewButton
        handleAddNewButton={() => setFormModal(true)}
        actionBtnEdit={handleEdit}
        hideDetails
        exportImportButton={false}
        filterChoosen={[
          {
            id: 'status',
            name: 'status',
            placeholder: 'Estado',
            options: options.status,
            isClearable: true,
            isSearchable: true,
            onChange: (value) => handleFilterChange(value, 'status'),
          },
          {
            id: 'capacity',
            name: 'capacity',
            placeholder: 'Capacidad',
            options: options.capacity,
            isClearable: true,
            isSearchable: true,
            onChange: (value) => handleFilterChange(value, 'capacity'),
          },
          {
            condition: userProvider,
            id: 'provider_id',
            name: 'provider_id',
            placeholder: 'Proveedor',
            options: options.provider_id,
            isClearable: true,
            isSearchable: true,
            onChange: (value) => handleFilterChange(value, 'provider_id'),
          },
        ]}
        cols_search="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
        cols_search_div="col-12"
        cols_filters="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3"
        cols_filters_div="col-12"
      />

      {formModal && (
        <TrucksNew
          modalForm={formModal}
          setModalForm={setFormModal}
          truckId={truckId}
          setTruckId={setTruckId}
          refetchMain={refetch}
        />
      )}
    </>
  )
}

export default Trucks
